import { useState } from "react";
import { useLocation } from "react-router-dom";
import useStyles from "./styles";
import logo from "../../assets/images/logo.svg";
import generateImg from "../../assets/images/generate.png";
import { Icon } from "@iconify/react";
import { httprequest } from "../../data/api";
import { toast } from "react-toastify";

const ReferralSuccess = () => {
  const classes = useStyles();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [isSending, setIsSending] = useState(false);

  const referralLink = location.state?.referralLink || "Link not found";
  const referralCode = location.state?.referralCode || "Code not found";

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
  };

  const handleSendEmail = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please provide an email address");

      return;
    }

    setIsSending(true);
    try {
      const payload = {
        code: referralCode,
        recipient_email: email
      };

      const response = await httprequest.post("/api/v1/referrals/send", payload);
      if (response?.data?.status === "success" || response?.status === 200 || response?.data?.data) {
        toast.success(response?.data?.message || "Referral sent successfully!");
        setEmail("");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to send referral email");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className={classes.referralWrapper}>
      <div className={classes.referralLeft}>
        <div className={classes.referralLogoContainer}>
          <img src={logo} alt="Shelf21 Logo" className={classes.referralLogo} />
        </div>

        <div className={classes.referralIllustration}>
          <img src={generateImg} alt="Referral Success" className={classes.referralImg} />
        </div>

        <div className={classes.referralLeftText}>
          <h1>You're all set!</h1>
          <p>Share this link with your school admin to complete the referral.</p>
        </div>
      </div>

      <div className={classes.referralRight}>
        <div className={classes.referralFormCard}>
          <div className={classes.referralFormHeader}>
            <h2>Referral link Generated</h2>
            <p>Share this link with your school owner or administrator to complete the signup.</p>
          </div>

          <div className={classes.howItWorksContainer}>
            <div className={classes.howItWorksStep}>
              <div className={classes.stepIconContainer}>
                <Icon icon="lucide:message-square-text" />
              </div>
              <div className={classes.stepTitle}>Send Invitation</div>
              <div className={classes.stepDescription}>
                Send your referral link to friends and tell them how shelf21 work
              </div>
              <div className={classes.stepConnector}>
                <svg className={classes.connectorSvg} viewBox="0 0 100 20" preserveAspectRatio="none">
                  <path d="M0,10 Q25,20 50,10 T100,10" fill="none" stroke="#cccccc" strokeWidth="1" strokeDasharray="4,4" />
                </svg>
              </div>
            </div>

            <div className={classes.howItWorksStep}>
              <div className={classes.stepIconContainer}>
                <Icon icon="lucide:user-plus" />
              </div>
              <div className={classes.stepTitle}>Registration</div>
              <div className={classes.stepDescription}>
                Let them register to our services using your referral link
              </div>
              <div className={classes.stepConnector}>
                <svg className={classes.connectorSvg} viewBox="0 0 100 20" preserveAspectRatio="none">
                  <path d="M0,10 Q25,20 50,10 T100,10" fill="none" stroke="#cccccc" strokeWidth="1" strokeDasharray="4,4" />
                </svg>
              </div>
            </div>

            <div className={classes.howItWorksStep}>
              <div className={classes.stepIconContainer}>
                <Icon icon="lucide:trophy" />
              </div>
              <div className={classes.stepTitle}>Reward</div>
              <div className={classes.stepDescription}>
                Referrer receives a reward after successful onboarding
              </div>
            </div>
          </div>

          <div className={classes.formSection}>
            <div className={classes.sectionTitle}>Your referral link</div>
            <div className={classes.sectionDescription}>
              Anyone who signs up using this link will be linked to your referral.
            </div>
            <div className={classes.inputWithButton}>
              <input
                type="text"
                className={classes.inputField}
                value={referralLink}
                readOnly
              />
              <button
                type="button"
                className={classes.copyButton}
                onClick={() => handleCopy(referralLink)}
              >
                Copy link
              </button>
            </div>
          </div>

          <div className={classes.formSection}>
            <div className={classes.sectionTitle}>Referral code</div>
            <div className={classes.sectionDescription}>
              You can also share your referral link by copying and sharing or sending it on your social media
            </div>
            <div className={classes.inputWithButton}>
              <input
                type="text"
                className={classes.inputField}
                value={referralCode}
                readOnly
              />
              <button
                type="button"
                className={classes.iconButton}
                onClick={() => handleCopy(referralCode)}
              >
                <Icon icon="lucide:copy" />
              </button>
            </div>
          </div>

          <div className={classes.formSection}>
            <div className={classes.sectionTitle}>Share via email (optional)</div>
            <div className={classes.sectionDescription}>
              Send the referral directly to your school administrator.
            </div>
            <form onSubmit={handleSendEmail} className={classes.inputWithButton}>
              <input
                type="email"
                className={classes.inputField}
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button type="submit" className={classes.sendIconButton} disabled={!email || isSending}>
                {isSending ? (
                  <Icon icon="lucide:loader-2" />
                ) : (
                  <Icon icon="lucide:send" />
                )}
              </button>
            </form>
          </div>

          <div className={classes.footerText}>
            Need help? <a href="#">Contact support</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralSuccess;
